import { useTranslation } from 'react-i18next'

import { useContentOverflow, useLinkLikeClick } from '../../../../hooks'
import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import Button from '../../../Button'
import { FloatingTooltip } from '../../../Floating'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import {
  QA_NAME_APPLICANT_PROFILE_MATCHED_LISTING_OPEN,
  QA_NAME_APPLICANT_PROFILE_WIDGET_MATCHED_LISTING,
} from './RentalPortalApplicantProfileWidgetMatchedListing.constants'
import {
  getApplicantMatchedListingFacts,
  getApplicantMatchedListingUrl,
} from './RentalPortalApplicantProfileWidgetMatchedListing.utils'

import * as styles from './RentalPortalApplicantProfileWidgetMatchedListing.module.css'

import ChevronRightIcon from '../../../../icons/chevrons/right.svg'
import RentalPortalIcon from '../../../../icons/rental-portal.svg'

function RentalPortalApplicantProfileWidgetMatchedListing() {
  const { t } = useTranslation()

  const { handleClick: handleLinkClick } = useLinkLikeClick()

  const { applicantData, isInitiated } = useApplicantProfileContext()

  const matchedListing = applicantData?.matched_listing

  const unitLabel = getListingUnitLabel({ listing: matchedListing, t })

  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [unitLabel],
  })

  function handleClickOpenListing(event) {
    handleLinkClick({
      event,
      link: getApplicantMatchedListingUrl(matchedListing),
    })
  }

  return (
    <Widget
      contentContainerProps={{ className: styles.content }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated || !applicantData}
      qaName={QA_NAME_APPLICANT_PROFILE_WIDGET_MATCHED_LISTING}
      title={t('RentalPortal.ApplicantProfileMatchedListingWidgetTitleKey')}
    >
      <div className={styles.unitRow}>
        <Avatar
          Icon={RentalPortalIcon}
          className={styles.unitIcon}
          size={AVATAR_HEIGHT_24}
        />
        <FloatingTooltip content={unitLabel} disabled={!overflow}>
          <Text className={styles.unit} ref={setContentOverflowRef}>
            {unitLabel}
          </Text>
        </FloatingTooltip>
      </div>
      <Text isSecondary className={styles.facts}>
        {getApplicantMatchedListingFacts({ matchedListing, t })}
      </Text>
      <Button.Text
        afterIconProps={{ Icon: ChevronRightIcon }}
        className={styles.openButton}
        qaName={QA_NAME_APPLICANT_PROFILE_MATCHED_LISTING_OPEN}
        text={t('RentalPortal.ApplicantProfileMatchedListingOpenBtnKey')}
        onClick={handleClickOpenListing}
      />
    </Widget>
  )
}

export default RentalPortalApplicantProfileWidgetMatchedListing
